import { render, staticRenderFns } from "./scientistrz.vue?vue&type=template&id=18722531&scoped=true"
import script from "./scientistrz.vue?vue&type=script&lang=js"
export * from "./scientistrz.vue?vue&type=script&lang=js"
import style0 from "./scientistrz.vue?vue&type=style&index=0&id=18722531&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18722531",
  null
  
)

export default component.exports